import { createContext } from "react";
import { PortfolioService } from "../services/portfolio.service";

export const PortfolioAppContext = createContext({
    portfolioService: undefined as PortfolioService | undefined,
});
